import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor() {
    //load from cache
    let pt = localStorage.getItem("profile");
    if (pt) this.profile.next(JSON.parse(pt));
    this.isFirstUsage = !pt;
    let lc = localStorage.getItem("langcode");
    if (lc) this.langCode.next(lc);
    let cc = localStorage.getItem("cachecode");
    if (cc) this.cacheCode.next(cc);
  }

  public isFirstUsage = false;

  public getProfileNow() {
    return this.profile.value;
  }

  public getProfile() {
    return this.profile;
  }

  public setProfile(p) {
    localStorage.setItem("profile", JSON.stringify(p))
    this.profile.next(p);
  }



  private langCode = new BehaviorSubject('ENG');
  private cacheCode = new BehaviorSubject('JIT');
  private profile = new BehaviorSubject({
    email: "",
    name: "",
    institution: "",
    class: "",
    edulevel: "",
    specialty: "",
  });

  public getLanguageCode(): Observable<string> {
    return this.langCode;
  }

  public languageCodeNow(): string {
    return this.langCode.value;
  }

  public setLanguageCode(code: string) {
    localStorage.setItem("langcode", code);
    this.langCode.next(code);
  }

  public ackTerms() {
    localStorage.setItem("ackTerms", "yes");
  }

  public getCacheCode(): Observable<string> {
    return this.cacheCode;
  }

  public cacheCodeNow(): string {
    return this.cacheCode.value;
  }


  public setCacheCode(code: string) {
    localStorage.setItem("cachecode", code)
    this.cacheCode.next(code);
  }

}
